import { axiosInstance as axios } from "../../redux/constants/axiosInstance";
const API_URL = process.env.REACT_APP_API_URL;

const simpleRequest = async (url, method, data = {}) => {
  return await axios({
    method,
    url: `${API_URL}${url}`,
    data: { ...data },
    headers: { "Content-Type": "application/json" },
  })
    .then((res) => res?.data)
    .catch((err) => err?.reponse?.data);
};
export default simpleRequest;
